import React from 'react';
import { Route, Redirect } from 'react-router-dom';
function PrivateStateFullRoute({ children, ...rest }) {
	return (
		<Route
			{...rest}
			render={({ location }) => {
				const user = sessionStorage && sessionStorage.getItem('state');
				const API_RESULT = sessionStorage && sessionStorage.getItem('API_RESULT');
				if (user) {
					if (API_RESULT === location.state.searchToken) {
						location.state = JSON.parse(user);
						return React.cloneElement(children, location);
					} else {
						return <Redirect to="/error" />;
					}
				} else {
					return <Redirect to="/error" />;
				}
			}}
		/>
	);
}
export default PrivateStateFullRoute;
